import React, { createContext, useContext, useState, ReactNode } from "react";
import { BPNLOFFER } from "../../../../model/customer/customer";
import { PaymentInfo } from "../constant";
import { NextOrderPayment } from "../../../../model/orders/orders";

interface ViewContextType {
	currentView: string;
	orderId: string;
	setView: (view: "default" | "acceptOffer" | "authorizePayment" | "initialDeposit" | "repayment") => void;
	setOrder: (orderId: string) => void;
	bnplOfferStatus: string;
	setOfferStatus: (status: BPNLOFFER | "") => void;
	paymentInfo: PaymentInfo | undefined;
	updatePaymentInfo: (info: PaymentInfo | undefined) => void;
	nextPaymentInfo: NextOrderPayment | undefined;
	updateNextPaymentInfo: (info: NextOrderPayment | undefined) => void;
  resetContext: () => void;
}

const ViewContext = createContext<ViewContextType | undefined>(undefined);

export const ViewProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [currentView, setCurrentView] = useState("default");
	const [orderId, setCurrentOrderId] = useState("");
	const [bnplOfferStatus, setBnplOfferStatus] = useState("");
	const [paymentInfo, setPaymentInfo] = useState<PaymentInfo | undefined>();
	const [nextPaymentInfo, setNextPaymentInfo] = useState<NextOrderPayment | undefined>();

	const setView = (view: string) => {
		setCurrentView(view);
	};

	const setOrder = (orderId: string) => {
		setCurrentOrderId(orderId);
	};

	const setOfferStatus = (status: BPNLOFFER | "") => {
		setBnplOfferStatus(status);
	};

	const updatePaymentInfo = (info: PaymentInfo | undefined) => {
		setPaymentInfo(info);
	};
	const updateNextPaymentInfo = (info: NextOrderPayment | undefined) => {
		setNextPaymentInfo(info);
	};

	const resetContext = () => {
		setView("default");
		setNextPaymentInfo(undefined);
		setPaymentInfo(undefined);
	};

	return (
		<ViewContext.Provider
			value={{
				currentView,
				orderId,
				bnplOfferStatus,
				paymentInfo,
				nextPaymentInfo,
				setOrder,
				setView,
				setOfferStatus,
				updatePaymentInfo,
				updateNextPaymentInfo,
        resetContext
			}}
		>
			{children}
		</ViewContext.Provider>
	);
};

export const useView = () => {
	const context = useContext(ViewContext);
	if (context === undefined) {
		throw new Error("useView must be used within a ViewProvider");
	}
	return context;
};
